<template>
  <div class="row primary-filter">
    <div class="col-md-auto filter-grid">
      <Breadcrumb @readyForBillingClicked="handleReadyForBillingClick" @invoiceClicked="handleInvoiceClick"/>
      <div class="popover-custom no-border with-shadow"  v-if="viewBackRouteDialog">
        <div class="popover-body bg-white w-300">
          <div style="margin-bottom: 2rem;">
                  <span class="text-bold" style="font-weight: 900; font-size: 1.5rem;">{{ $t('ATTENTION') }}</span>
                </div>
          <p>
            <span>{{ $t('DISCARD_INDENTS_REVIEW') }}</span>
          </p>
          <div class="popover-footer">
            <Button type="text" size="mini" @click="viewBackRouteDialog = false">
              {{ $t('INDENT_NO') }}
            </Button>
            <Button type="text" size="mini" style="background-color: #008AFF; color: white;" @click="continueToRoute">
              {{ $t('YES_DISCARD') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div class="col filter-grid">
      <div class="row">
        <div class="col">
          <div class="app-search-label">
            <div v-if="showPopup">
              <SearchPopup
                :searchParameters="indentSearchParameters"
                :presearchedParams="searchedParams"
                :disableSearchFields="true"
                @closePopup="closePopup"
                @search="searchByParameter"
              />
            </div>
            <div class="searchterm tagblock" v-if="!showPopup" @click="onClick">
              <svgicon name="search" width="15" height="15" :original="true" />
              <span v-if="noParams" class="inputtextlabel">{{ $t('SEARCH') }}</span>
              <span type="text" class="tagblock_list" v-else>
                <span v-for="(value, name, index) in searchedParams" :key="index">
                  <span v-if="value">
                    <Tag closable @close="removeParamTag(name)">
                      <div class="searchtag-title">{{ getTagByName(name) }}</div>
                      {{ value }}
                    </Tag>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-auto filter-grid filter-button">
      <span v-if="isDataExist">
        <ul class="filter-btn-group inlinelist" v-if="!isLoading">
          <li v-if="$hasFeature('freight_bill')">
            <button class="btn header_sbtn" @click="exportFreightBill()">{{ $t('INVOICE_EXPORT') }}</button>
          </li>
          <li v-if="isIndentSelected && !isInvoices">
            <button class="btn header_sbtn" @click="$emit('remove')">{{ $t('REMOVE') }}</button>
          </li>
          <li v-if="isIndentSelected && isInvoices && isPaymentRemoveEnabled && indentsCount > 1">
            <button class="btn header_sbtn" @click="$emit('removeSelectedPayment')">{{ $t('REMOVE_PAYMENT') }}</button>
          </li>
          <li v-if="isChangesPresent" @click="$emit('clearAll')">
            <button class="btn header_sbtn">{{ $t('CLEAR_ALL') }}</button>
          </li>
          <li v-if="isChangesPresent">
            <button class="btn header_sbtn" :disabled="saving" @click="save()">{{ saving ? 'SAVING...' : 'SAVE' }}</button>
          </li>
          <li v-if="currentRoute !== 'IndentDetails'">
            <div>
            <Dropdown trigger="click"  @visible-change="dropdownOpen = !dropdownOpen"
              :class="{ dropdownbutton: dropdownOpen }">
              <button type="primary" class="btn btn-secondary header_sbtn text-sm">
                {{ $t('INVOICE_PREVIEW') }}
                <svgicon
                  name="categorydropdown"
                  class="dropdown-icon"
                  width="10" height="10"
                  :original="true"/>
              </button>
              <Dropdown-menu slot="dropdown">
                <Dropdown-item v-if="(showInvoicePreview)">
                  <a :href="url(invoiceId)"
                    class="format-text"
                    target="_blank"
                    @click="$addGAEvent('Transporter - Pay', 'Click', 'Transporter - Indent Details:Invoice Preview Button')">
                    {{ $t('INVOICE_PRINT') }}
                  </a>
                </Dropdown-item>
                <Dropdown-item v-if="invoiceUrl()">
                  <a :href="invoiceUrl()"
                    class="format-text"
                    target="_blank"
                    @click="$addGAEvent('Transporter - Pay', 'Click', 'Transporter - Indent Details:E-Invoice Preview Button')">
                    {{ $t('E_INVOICE') }}
                  </a>
                </Dropdown-item>
                  <Dropdown-item v-if="(transporterAnnexureEnabled && showMailInvoiceAnnexure)">
                  <a :href="printAnnexure(invoiceId, 1)"
                    class="format-text"
                    target="_blank"
                    @click="$addGAEvent('Transporter - Pay', 'Click', 'Transporter - Indent Details:Annexure-1 Preview Button')">
                    {{ $t('ANNEXURE_1_PRINT') }}
                  </a>
                </Dropdown-item>
                  <Dropdown-item v-if="(transporterAnnexureEnabled && showMailInvoiceAnnexure)">
                    <a
                    :href="printAnnexure(invoiceId, 2)"
                    class="format-text"
                    target="_blank"
                    @click="$addGAEvent('Transporter - Pay', 'Click', 'Transporter - Indent Details:Annexure-2 Preview Button')">
                    {{ $t('ANNEXURE_2_PRINT') }}
                  </a>
                </Dropdown-item>
              </Dropdown-menu>
            </Dropdown>
            </div>
          </li>
          <li v-if="currentRoute !== 'IndentDetails' && (transporterAnnexureEnabled && showMailInvoiceAnnexure)">
            <button class="btn header_sbtn" target="_blank" @click="mailAnnexure">{{ $t('MAIL_INVOICE_AND_ANNEXURE') }}</button>
          </li>
          <li v-if="currentRoute === 'IndentDetails' && !isFreightBill">
            <BulkUpload @handleFileUpload='handleFileUpload' :sampleFileName='fileName'/>
          </li>
          <li>
            <button class="btn header_pbtn" @click="checkViewed"
              :class="isChangesPresent ? 'disablebtn' : ''" :disabled="isChangesPresent">
              {{ $t('INVOICE_SUMMARY') }}
            </button>
            <div class="popover-custom no-border with-shadow"  v-if="viewSummaryDialog">
              <div class="popover-body bg-white w-300">
                <div style="margin-bottom: 2rem;">
                  <span class="text-bold" style="font-weight: 900; font-size: 1.5rem;">{{ $t('ATTENTION') }}</span>
                </div>
                <p>
                  <span>{{ $t('PARTIAL_INDENTS_REVIEW') }}</span>
                </p>
                <div class="popover-footer">
                  <Button type="text" size="mini" @click="viewSummaryDialog = false">
                    {{ $t('INDENT_NO') }}
                  </Button>
                  <Button type="text" size="mini" style="background-color: #008AFF; color: white;"  @click="viewSummaryDialog = false; $emit('openSummary')">
                    {{$t('INDENT_YES')}}
                  </Button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </span>
      <span v-else-if = "currentRoute === 'IndentDetails'">
        <ul class="filter-btn-group inlinelist" v-if="!isLoading">
          <BulkUpload @handleFileUpload='handleFileUpload' :sampleFileName='fileName'/>
        </ul>
      </span>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '@/components/common/Breadcrumb';
import BulkUpload from './BulkUpload';
import SearchPopup from '@common/components/SearchPopup';
import { indentSearchParameters } from '@/constants/payments';
import AttachmentConstants from '@common/constants/AttachmentConstants';

export default {
  props: {
    viewed: {
      type: Number,
      default: 0,
    },
    total_rows: {
      type: Number,
      default: 0,
    },
    chargesHeaders: {
      type: Object,
      default: () => {},
    },
    tempCharge: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    isDataExist: {
    },
    isChangesPresent: {
      type: Boolean,
      default: false,
    },
    isIndentSelected: {
      type: Boolean,
      default: false,
    },
    isInvoices: {
      type: Boolean,
      default: false,
    },
    indentsCount: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    invoiceId: {
      type: Number,
      default: null,
    },
    invoiceURL: {
      type: String,
      default: null,
    },
    showInvoicePreview: {
      type: Boolean,
      default: false,
    },
    showMailInvoiceAnnexure: {
      type: Boolean,
      default: false,
    },
    isFreightBill: {
      type: Boolean,
      default: false,
    },
    transporterAnnexureEnabled: {
      type: Boolean,
      default: false,
    },
    freightBillNo: {
      type: String,
      default: '',
    },
    freightBillId: {
      type: Number,
      default: null,
    },
    invoiceUuid: {
      type: String,
      required: true,
    },
    isPaymentRemoveEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Breadcrumb,
    SearchPopup,
    BulkUpload,
  },
  data() {
    return {
      viewSummaryDialog: false,
      viewBackRouteDialog: false,
      currentRoute: '',
      AttachmentConstants,
      indentSearchParameters,
      saving: false,
      showPopup: false,
      searchedParams: {},
      fileName: 'ready_for_billing_bulk_upload.xlsx',
      dropdownOpen: false,
    };
  },
  created() {
    this.currentRoute = this.$router.history.current.name;
  },
  mounted() {
    this.saving = false;
  },
  computed: {
    noParams() {
      return Object.values(this.searchedParams).every(parameter => !parameter);
    },
  },
  methods: {
    checkViewed() {
      if (this.viewed === this.total_rows) {
        this.viewSummaryDialog = false;
        this.$emit('openSummary');
      } else {
        this.viewSummaryDialog = true;
      }
      return this.viewSummaryDialog;
    },
    handleReadyForBillingClick() {
      if (this.viewed > 0) {
        this.viewBackRouteDialog = true;
      } else {
        this.$router.push({ name: 'payments' });
      }
      return this.viewBackRouteDialog;
    },
    handleInvoiceClick() {
      if (this.viewed > 0) {
        this.viewBackRouteDialog = true;
      } else {
        this.$router.push({ name: 'invoices' });
      }
      return this.viewBackRouteDialog;
    },
    continueToRoute() {
      this.viewBackRouteDialog = false;
      this.$router.push({ name: 'payments' });
    },
    getTagByName(name) {
      return this.indentSearchParameters.find(param => param.query === name).name;
    },
    unCheck(value) {
      this[value] = null;
    },
    removeParamTag(tag) {
      this.unCheck(tag);
      this.searchedParams[tag] = null;
    },
    searchByParameter(query, isReset = false) {
      const searchList = Object.keys(query);
      searchList.forEach((value) => {
        if (query[value]) {
          const serachName = this.indentSearchParameters.find(term => term.query === value).name || '';
          const searchKey = serachName.replace(/\b[a-zA-Z]/g, match => match.toUpperCase());
          this.$ga.event('Indent', 'Textbox', `Search By ${searchKey}`);
        }
      });
      this.searchedParams = query;
      if (!isReset) {
        this.search();
        this.closePopup();
      }
    },
    closePopup() {
      this.showPopup = false;
    },
    onClick() {
      this.showPopup = true;
    },
    search() {
      const isValidSearch = Object.values(this.searchedParams).some(val => val);
      if (isValidSearch) {
        const searchParams = {
          order_number: this.searchedParams.indent_number || null,
          shipment_number: this.searchedParams.shipment_number || null,
          lr_number: this.searchedParams.lr_number || null,
        };
        this.$emit('search', searchParams);
      } else {
        this.$errorMessage({ message: 'Enter a valid keyword' });
      }
    },
    handleFileUpload(file) {
      this.$emit('onUpload', file);
      this.$refs.file.value = '';
    },
    async mailAnnexure() {
      this.$addGAEvent('Transporter - Pay', 'Click', 'Transporter - Indent Details:Invoice Mail Annexure Button');
      this.$emit('mailAnnexure');
    },
    async printInvoice(invoiceNumber) {
      const result = await this.$store.dispatch('paymentsV2/getPrintFile', { invoiceNumber });
      const winlogicalname = 'detailPDF';
      const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
        'resizable,screenX=50,screenY=50,width=850,height=1050';
      const htmlText = `${'<embed width=100% height=100%'
        + ' type="application/pdf"'
        + ' src="data:application/pdf;b64,'}${escape(result)}"></embed>`;
      const detailWindow = window.open('', winlogicalname, winparams);
      detailWindow.document.write(htmlText);
      detailWindow.document.close();
    },
    invoiceUrl() {
      return this.invoiceURL;
    },
    url(invoiceNumber) {
      const isDevelopment = process.env.NODE_ENV === 'development';
      const baseURL = isDevelopment ? 'http://localhost:3002/api' : '/api';
      let printUrl;
      if (invoiceNumber) {
        if (this.$hasFeature('freight_bill')) {
          printUrl = `${baseURL}/v2/transporter/freightBill/${this.freightBillId}/print`;
        } else {
          printUrl = `${baseURL}/v2/transporter/invoice/${this.invoiceUuid}/${invoiceNumber}/print`;
        }
      } else {
        printUrl = `${baseURL}/v2/transporter/freightBill/${this.$router.history.current.query.freightBillId}/print`;
      }
      return printUrl;
    },
    printAnnexure(invoiceId, type) {
      const isDevelopment = process.env.NODE_ENV === 'development';
      const baseURL = isDevelopment ? 'http://localhost:3002/api' : '/api';
      return `${baseURL}/v2/transporter/annexure/${type}/${this.invoiceUuid}/${invoiceId}/print`;
    },

    async exportFreightBill() {
      const result = await this.$store.dispatch('paymentsV2/exportFreightBill', { freightBillId: this.freightBillNo });
      if (result.data) {
        this.$successMessage({ message: result.data.message });
      }
    },
    async save() {
      this.saving = true;
      this.$emit('save');
    },
  },
  watch: {
    isChangesPresent(newVal) {
      if (!newVal) {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-menu__item .format-text {
    color: #0178de;
    font-size: 1.1rem;
    font-weight: 500;
    text-decoration: none;
    text-align: right;
    font-style: normal;
}
</style>
<style scoped>
.popover-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
}
.popover-body {
  position: absolute;
  top: 40%;
  left: 40% !important;
}
</style>
